module.exports = __webpack_public_path__ + "img/fi-rr-spa.fd896c59.svg";